module.exports = __webpack_public_path__ + "static/media/LogoHelenLabs2.5b48a93b.svg";